import { DealerApplication, defaultContractInformation, defaultSaleVehicle, emptyDealerApplicationCustomer } from "@amsanalytics/react-shared-library";

export const defaultDealerApplication: DealerApplication = {
  transactionTypeId: '',
  locationId: '',
  applicant: emptyDealerApplicationCustomer,
  saleVehicle: defaultSaleVehicle,
  contractInformation: defaultContractInformation,
};